module.exports = __webpack_public_path__ + "img/treatment-bg-mini.fbfa821b.png";